import React from 'react';
import { GenericSectionContent } from '../../types';
import { useAdditionalCss } from '../../../helpers/useAdditionalCss';
import { textAlignmentClass, SECTION_SPACING } from '../../../helpers/rendering';

// Vortex ← Methven `section-with-video`: optional centered title + full-width responsive iframe video.
export default function VortexRendering({ content }: { content: GenericSectionContent }) {
  const { title, content_alignment, cards = [], additional_css, additional_css_class_names } = content;
  const { uniqueClass, scopedAdditionalCss } = useAdditionalCss(additional_css, 'VortexRendering');
  const align = textAlignmentClass(content_alignment);
  const videoUrl = cards[0]?.external_media_url;

  return (
    <>
      {scopedAdditionalCss && <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />}
      <div className={`${SECTION_SPACING} px-40 md:px-48 lg:px-80 2xl:px-120 ${[additional_css_class_names, uniqueClass].filter(Boolean).join(' ')}`}>
        {title && (
          <div className={`block pb-32 lg:pb-48 text-28 font-medium leading-10 text-primary-black xl:text-36 2xl:text-48 ${align}`}>
            {title}
          </div>
        )}
        {videoUrl && (
          <div className="video-container mx-auto w-full">
            {/* 16:9 ratio box (padding-bottom hack — robust without the aspect-ratio utility) */}
            <div className="relative w-full pb-[56.25%]">
              <iframe
                src={videoUrl}
                title={title ?? 'video'}
                loading="lazy"
                allowFullScreen
                className="absolute inset-0 h-full w-full"
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
